// Investiture
import React from 'react';
import { Hindicca2class2026 } from '../views';

const InvestiturePage = () => {
  return <Hindicca2class2026 />;
};

export default InvestiturePage;
